@if (level === '1') {
    <h1 [ngStyle]="style">
        <ng-container *ngTemplateOutlet="content" />
    </h1>
}

@if (level === '2') {
    <h2 [ngStyle]="style">
        <ng-container *ngTemplateOutlet="content" />
    </h2>
}

@if (level === '3') {
    <h3 [ngStyle]="style">
        <ng-container *ngTemplateOutlet="content" />
    </h3>
}

@if (level === '4') {
    <h4 [ngStyle]="style">
        <ng-container *ngTemplateOutlet="content" />
    </h4>
}

@if (level === '5') {
    <h5 [ngStyle]="style">
        <ng-container *ngTemplateOutlet="content" />
    </h5>
}

@if (level === '6') {
    <h6 [ngStyle]="style">
        <ng-container *ngTemplateOutlet="content" />
    </h6>
}

<ng-template #content>
    <ng-content />
</ng-template>
